// Projectniveau: tags, notities en de projectlog (SPEC 27okt 1 en 6).

/** Types in de projectlog — filter "op type" (27okt 6). */
export const LOG_CATEGORIEEN = ['calculatie', 'prijs', 'status', 'notitie', 'tag', 'systeem'] as const;
export type LogCategorie = (typeof LOG_CATEGORIEEN)[number];

export const LOG_CATEGORIE_LABEL: Record<LogCategorie, string> = {
  calculatie: 'Calculatie',
  prijs: 'Prijs',
  status: 'Status',
  notitie: 'Notitie',
  tag: 'Label',
  systeem: 'Systeem',
};

/** Automatische tags (27okt 6): verdwijnen vanzelf als de oorzaak weg is. */
export const AUTO_TAG_PRIJSAFWIJKING = 'tag_prijsafwijking';
export const AUTO_TAG_WACHT_OP_OPLEVERING = 'tag_wacht_op_oplevering';

/** Een notitie mag binnen deze termijn door de auteur bewerkt worden; daarna enkel een nieuwe notitie. */
export const NOTITIE_BEWERK_MINUTEN = 15;

export function notitieBewerkbaar(aangemaaktOp: string, nu: Date = new Date()): boolean {
  const t = Date.parse(aangemaaktOp);
  return Number.isFinite(t) && nu.getTime() - t <= NOTITIE_BEWERK_MINUTEN * 60 * 1000;
}

/** Tagnaam normaliseren voor vergelijking en opslag: spaties samenvoegen, geen hoofdlettergevoeligheid. */
export function normaliseerTagNaam(naam: string): string {
  return naam.replace(/\s+/g, ' ').trim();
}

export interface LogWijziging {
  /** Wat er veranderde: entiteit (calculatie, werkpost, meerwerk, extra regel …) en veld. */
  entiteit: string;
  veld: string;
  /** Mens-leesbaar label van de rij, bv. de naam van de post. */
  label?: string;
  oud: unknown;
  nieuw: unknown;
}
